import { lazy, Suspense, type ReactNode } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { MarketingHome } from "./pages/MarketingHome";
import { LocaleProvider } from "./i18n";

const AdminStudio = lazy(() => import("./pages/AdminStudio").then((module) => ({ default: module.AdminStudio })));
const ContributionFlow = lazy(() => import("./pages/ContributionFlow").then((module) => ({ default: module.ContributionFlow })));
const Memorial = lazy(() => import("./pages/Memorial").then((module) => ({ default: module.Memorial })));
const PrintStudio = lazy(() => import("./pages/PrintStudio").then((module) => ({ default: module.PrintStudio })));
const Privacy = lazy(() => import("./pages/Privacy").then((module) => ({ default: module.Privacy })));
const Slideshow = lazy(() => import("./pages/Slideshow").then((module) => ({ default: module.Slideshow })));
const OrganizerAuth = lazy(() => import("./pages/OrganizerAuth").then((module) => ({ default: module.OrganizerAuth })));

function LoadedPage({ children }: { children: ReactNode }) {
  return <Suspense fallback={<main className="route-loading" aria-live="polite"><span className="brand-mark" aria-hidden="true"><i /><i /><i /></span><p>Opening Gathered…</p></main>}>{children}</Suspense>;
}

export default function App() {
  return (
    <LocaleProvider>
      <Routes>
        <Route path="/" element={<MarketingHome />} />
        <Route path="/share" element={<LoadedPage><ContributionFlow /></LoadedPage>} />
        <Route path="/memorial" element={<LoadedPage><Memorial /></LoadedPage>} />
        <Route path="/slideshow" element={<LoadedPage><Slideshow /></LoadedPage>} />
        <Route path="/admin" element={<LoadedPage><AdminStudio /></LoadedPage>} />
        <Route path="/login" element={<LoadedPage><OrganizerAuth /></LoadedPage>} />
        <Route path="/print/:format" element={<LoadedPage><PrintStudio /></LoadedPage>} />
        <Route path="/privacy" element={<LoadedPage><Privacy /></LoadedPage>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </LocaleProvider>
  );
}
